import db from "./firebaseConfig";
import { collection, doc } from "firebase/firestore";
import { Collections } from "../utils/constants";

export const getCompaniesRef = (id) => doc(db, Collections.companies, id);
export const getCompaniesCollectionRef = () =>
  collection(db, Collections.companies);
export const getRolesRef = (id) => doc(db, Collections.roles, id);
export const getRolesCollectionRef = () => collection(db, Collections.roles);

export const getWidgetRef = (ref, id) => doc(ref, Collections.widgets, id);
export const getWidgetCollectionRef = (ref) =>
  collection(ref, Collections.widgets);

export const getPropertyRef = (id) => doc(db, Collections.properties, id);
export const getPropertyCollectionRef = () =>
  collection(db, Collections.properties);

// Packages
export const getPackagesCollectionRef = () =>
  collection(db, Collections.packages);
export const getPackageRef = (id) => doc(db, Collections.packages, id);

// Packages Privce
export const getPackagesPriceCollectionRef = () =>
  collection(db, Collections.price);
export const getPackagePriceRef = (id) => doc(db, Collections.price, id);

export const getVisitorRef = (id) => doc(db, Collections.visitors, id);
export const getVisitorCollectionRef = () =>
  collection(db, Collections.visitors);

export const getSessionRef = (visitorRef, id) =>
  doc(visitorRef, Collections.sessions, id);
export const getSessionCollectionRef = (visitorRef) =>
  collection(visitorRef, Collections.sessions);

export const getActivitiesRef = (sessionRef, id) =>
  doc(sessionRef, Collections.activities, id);
export const getActivitiesCollectionRef = (sessionRef) =>
  collection(sessionRef, Collections.activities);

export const getPropertyMemberRef = (ref, id) =>
  doc(ref, Collections.propertyMembers, id);
export const getPropertyMemberCollectionRef = (ref) =>
  collection(ref, Collections.propertyMembers);

export const getPropertyInvitedMemberRef = (ref, id) =>
  doc(ref, Collections.invitedPropertyMembers, id);
export const getPropertyInvitedMemberCollectionRef = (ref) =>
  collection(ref, Collections.invitedPropertyMembers);

export const getUserRef = (id) => doc(db, Collections.users, id);
export const getUserCollectionRef = () => collection(db, Collections.users);

export const getBanListRef = (id) => doc(db, Collections.banList, id);
export const getBanListCollectionRef = () =>
  collection(db, Collections.banList);

export const getShortcutsRef = (ref, id) => doc(ref, Collections.shortcuts, id);
export const getShortcutsCollectionRef = (ref) =>
  collection(ref, Collections.shortcuts);

export const getDepartmentsRef = (id) => doc(db, Collections.departments, id);
export const getDepartmentsCollectionRef = () =>
  collection(db, Collections.departments);

export const getSatisfactionReportRef = () => {
  const ref = doc(db, Collections.reports, "satisfactionReportRef");
  return collection(ref, "satisfactionReport");
};

export const getHistoriesRef = (id) => doc(db, Collections.histories, id);
export const getHistoriesCollectionRef = () =>
  collection(db, Collections.histories);

export const getChatVolumeReportRef = () => {
  const ref = doc(db, Collections.reports, "chatVolumeReportRef");
  return collection(ref, "chatVolumeReport");
};

export const getVisitorReportRef = () => {
  const ref = doc(db, Collections.reports, "visitorReportRef");
  return collection(ref, "visitorReport");
};

export const getPageViewsReportRef = () => {
  const ref = doc(db, Collections.reports, "pageViewReportRef");
  return collection(ref, "pageViewReport");
};

// Personal/Private Shortcuts
export const getShortcutCollection = () =>
  collection(db, Collections.allShortcuts);

export const getShortcutRef = (shortcutId) =>
  doc(db, Collections.allShortcuts, shortcutId);

// Contact List
export const getContactsCollection = () => collection(db, Collections.contacts);
export const getContactRef = (id) => doc(db, Collections.contacts, id);

// Feedback

export const getFeedbackCollectionRef = () =>
  collection(db, Collections.feedbacks);

// Triggers
export const getTriggersCollection = () => collection(db, Collections.triggers);

export const getTriggerRef = (triggerId) =>
  doc(db, Collections.triggers, triggerId);

// Subscriptions
export const getSubscriptionsCollectionRef = () =>
  collection(db, Collections.subscriptions);
export const getSubscriptionsRef = (id) =>
  doc(db, Collections.subscriptions, id);

// Refunds
export const getRefundsCollectionRef = () =>
  collection(db, Collections.refunds);
export const getRefundsRef = (id) => doc(db, Collections.refunds, id);

// Invoices
export const getInvoiceCollectionRef = () =>
  collection(db, Collections.invoices);
export const geInvoiceRef = (id) => doc(db, Collections.invoices, id);

// Coupons
export const getCouponsCollectionRef = () =>
  collection(db, Collections.coupons);
export const getCouponRef = (id) => doc(db, Collections.coupons, id);

// Vouchers
export const getVouchersCollectionRef = () =>
  collection(db, Collections.vouchers);
export const getVoucherRef = (id) => doc(db, Collections.vouchers, id);
